import { Actions as ImportActions } from "./state/actions";
import { State as ImportState } from "./state/state";
// import * as ImportFilters from "./filters";
export namespace Rtc {
  export import Actions = ImportActions;
  export import State = ImportState;
}
export default Rtc;
